import { CustomAlarmActivationMode } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-activation-confirmation-modal/custom-alarm-active-confirmation-modal.model';
import {
    CustomAlarmActionAmount,
    CustomAlarmModalTextContent,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';

export const CUSTOM_ALARM_ACTIVATION_MODAL_TEXTS: Record<
    CustomAlarmActivationMode,
    Record<CustomAlarmActionAmount, CustomAlarmModalTextContent>
> = {
    activate: {
        single: {
            headerText: 'settings.devices.custom-alarms.activation.modal.activate.single.title',
            bodyText: 'settings.devices.custom-alarms.activation.modal.activate.single.description',
        },
        multiple: {
            headerText: 'settings.devices.custom-alarms.activation.modal.activate.multiple.title',
            bodyText: 'settings.devices.custom-alarms.activation.modal.activate.multiple.description',
        },
    },
    deactivate: {
        single: {
            headerText: 'settings.devices.custom-alarms.activation.modal.deactivate.single.title',
            bodyText: 'settings.devices.custom-alarms.activation.modal.deactivate.single.description',
        },
        multiple: {
            headerText: 'settings.devices.custom-alarms.activation.modal.deactivate.multiple.title',
            bodyText: 'settings.devices.custom-alarms.activation.modal.deactivate.multiple.description',
        },
    },
};

export const CUSTOM_ALARM_ACTIVE_CONFIRMATION_BUTTON_TEXTS: Record<CustomAlarmActivationMode, string> = {
    activate: 'settings.devices.custom-alarms.actions.activate',
    deactivate: 'settings.devices.custom-alarms.actions.deactivate',
};
